// src/utils/hooks/useUpdateCount.js

import { getNotficationServiceConfig } from "../../utils/services/notifications";
import { getQueryParams } from "../../utils/helpers";
import { useFetch } from "../../utils/hooks/useFetch";
import { useDispatch } from "react-redux";
import { userActions } from "../../store/actions";

export const useUpdateCount = () => {
  const dispatch = useDispatch();
  const { performAction } = useFetch();

  const updateCount = async () => {
    const temp = { IsViewed: "false" };
    const queryParams = getQueryParams(temp);
    const { url, options } = getNotficationServiceConfig(queryParams);
    const response = await performAction(url, options);
    const notificationCount = response?.Result?.length;
    dispatch(userActions.setNotification(notificationCount));
  };
  return updateCount;
};
